import React from "react";
import { withRouter, Redirect } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const UserProfile = (props) => {

  if (!props.users.isAuthenticated) {
    return <Redirect to="/issue-tracker/" />
  }

  return (
    <div style={{padding: "10px"}}>
      <h2 style={{textAlign: "center"}}>My profile</h2>
      <p>Name: {props.users.firstName + " " + props.users.lastName}</p>
      <p>Email: {props.users.id}</p>
      <p>Contact: {props.users.contact}</p>
      <p>Location: {props.users.location}</p>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserProfile));
